<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal parking-pass-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" submittable autocomplete="off">
        <div cdkScrollable class="modal-dialog ">
            <spinner class="mobile-spinner" [spinnerShow]="showRequiredPassTypesSpinner"></spinner>
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">{{data.id ? 'Edit' : ' New'}} Parking Pass</h4>
                </div>
                <div class="modal-body">
                    <div class="row m-b-sm step-guide"
                         [ngClass]="{'only-create-and-summary': !termsAndConditions && !confirmationMessage && !showPaymentTab() && !disclaimerText}">
                        <div (click)="moveToTheNextStep('create-pass')" class="mtv-primary-color">
                            <span>Create Pass</span>
                        </div>
                        <div (click)="moveToTheNextStep('disclaimer')" *ngIf="disclaimerText"
                             [ngClass]="{'mtv-primary-color' : (step == 'disclaimer' || step == 'terms' || step == 'payment' || step == 'summary')}">
                            <span>Disclaimer</span>
                        </div>
                        <div (click)="moveToTheNextStep('terms')" *ngIf="termsAndConditions || confirmationMessage"
                            [ngClass]="{'mtv-primary-color' : (step == 'terms' || step == 'payment' || step == 'summary')}">
                            <span>Terms & Conditions</span>
                        </div>
                        <div (click)="moveToTheNextStep('payment')" *ngIf="showPaymentTab()"
                             [ngClass]="{'mtv-primary-color' : (step == 'payment' || step == 'summary')}">
                            <span>Payment</span>
                        </div>
                        <div (click)="moveToTheNextStep('summary')"
                             [ngClass]="{'mtv-primary-color' : (step == 'summary')}">
                            <span>Summary</span>
                        </div>
                    </div>
                    <div class="row m-b-md step-progress-bar">
                        <div class="col-sm-3"
                             [ngStyle]="{ 'width': calculateCurrentProgressBarLength() }"></div>
                    </div>

                    <div class="tab-content" *ngIf="step == 'create-pass'">
                        <!-- ___ Building ___ -->
                        <div class="row m-b-sm" [ngStyle]="{'display':authService.userIsResident? 'none': 'block'}">
                            <div class="col-md-4">
                                <label>Building</label>
                            </div>
                            <div class="col-md-8">
                                <select class="form-control" name="buildingId" [(ngModel)]="data.buildingId"
                                        (change)="changeBuilding($event.target.value)" #buildingSelect
                                        [disabled]="!parkingPassService.buildingsForUpdate.length || buildingSelectIsDisabled"
                                        required>
                                    <option value="" hidden></option>
                                    <option *ngFor="let build of parkingPassService.buildingsForUpdate" [value]="build.id">{{build.name}}</option>
                                </select>
                            </div>
                        </div>

                        <!-- ___ Lot ___ -->
                        <div class="row m-b-sm"
                             [ngStyle]="{'display':authService.userIsResident && lots.length === 1? 'none': 'block'}">
                            <div class="col-md-4">
                                <label>Lot</label>
                            </div>
                            <div class="col-md-8">
                                <select class="form-control" name="parkingLot" [(ngModel)]="data.parkingLot"
                                        (change)="changeLot($event.target.value)" #lotSelect
                                        [disabled]="!lots.length" required>
                                    <option value="" hidden></option>
                                    <option *ngFor="let lot of lots" [value]="lot.id">{{lot.name}}</option>
                                </select>
                                <spinner [spinnerShow]="buildingSelect.value &&
                                                        buildingSelect.value != 'null' &&
                                                        !lots.length && lotsAreLoading"></spinner>
                            </div>
                        </div>

                        <!-- ___ Rule ___ -->
                        <div class="row m-b-sm"
                             [ngStyle]="{'display':authService.userIsResident && rules.length === 1? 'none': 'block'}">
                            <div class="col-md-4">
                                <label>Rule</label>
                            </div>
                            <div class="col-md-8">
                                <select class="form-control" name="parkingRule" [(ngModel)]="data.parkingRule"
                                        (change)="changeRule($event.target.value)"
                                        [disabled]="!rules.length" required>
                                    <option value="" hidden></option>
                                    <option *ngFor="let rule of rules" [value]="rule.id">{{rule.name}}</option>
                                </select>
                                <spinner [spinnerShow]="lotSelect.value &&
                                                        lotSelect.value != 'null' &&
                                                        !rules.length"></spinner>
                            </div>
                        </div>

                        <!-- ___ Unit ___ -->
                        <div class="row m-b-sm" [ngStyle]="{'display':authService.userIsResident? 'none': 'block'}">
                            <div class="col-md-4">
                                <label style="margin-top: 4px;">Unit</label>
                            </div>
                            <div class="col-md-8 fourteenPixelText">
                                <search-select [ngModel]="data.suiteId" name="suiteId" #suiteSelect
                                               (ngModelChange)="changeUnit($event)"
                                               [data]="suiteToSearchSelect(suites)" required></search-select>
                                <input *ngIf="suiteSelect.value == '0'" class="form-control"
                                       [(ngModel)]="data.suiteNumber" name="otherSuite"
                                       placeholder="Other Unit Number" maxlength="255" required>
                                <spinner [spinnerShow]="(authService.userIsResident ||
                                                         (buildingSelect.value && buildingSelect.value != 'null')) &&
                                                        !suites.length"></spinner>
                            </div>
                        </div>

                        <!-- ___ Resident ___ -->
                        <div class="row m-b-sm" [ngStyle]="{'display':authService.userIsResident? 'none': 'block'}">
                            <div class="col-md-4">
                                <label>Resident</label>
                            </div>
                            <div class="col-md-8">
                                <select class="form-control" [ngModel]="data.residentId" name="residentId" #residentSelect
                                        (change)="changeResident($event.target.value)" [disabled]="!residents.length" required>
                                    <option value="" hidden></option>
                                    <option *ngFor="let resident of residents" [value]="resident.id">{{resident.fullName}}</option>
                                </select>
                                <input *ngIf="suiteSelect.value == '0' || residentSelect.value == '0'" class="form-control"
                                       placeholder="Other Resident Name" [(ngModel)]="data.residentFullName"
                                       name="otherResident" maxlength="255" required>
                                <spinner [spinnerShow]="suiteSelect.value &&
                                                        suiteSelect.value != 'null' && !residents.length"></spinner>
                            </div>
                        </div>

                        <!-- ___ Used Passes ___ -->
                        <div class="row m-b-sm"
                             *ngIf="gotUsedPasses"
                             [ngStyle]="{'display':authService.userIsResident? 'none': 'block'}">
                            <div class="col-md-4"></div>
                            <div class="col-md-8" *ngIf="usedPasses.length > 0 && getUsedPassesString().length > 0">
                                <div class="bold">Passes Used In {{currentMonth}}</div>
                                <div *ngFor="let pass of getUsedPassesString()">{{pass.used}} - {{pass.passTypeName}}</div>
                            </div>
                            <div class="col-md-8 bold" *ngIf="usedPasses.length === 0 || getUsedPassesString().length === 0">
                                No used passes in {{currentMonth}}
                            </div>
                        </div>

                        <hr *ngIf="!(authService.userIsResident && rules.length === 1 && lots.length === 1)">

                        <!-- ___ Visitor's Name ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Visitor's Name</label>
                            </div>
                            <div class="col-md-8">
                                <!--In order to use autocomplete with options list repositioning on scrolling,
                                    ScrollDispatchModule must be imported in the component module and
                                    cdkScrollable must be placed on scrollable element-->
                                <div class="input-group fourteenPixelText autocomplete-input">
                                    <input name="visitorFullName"
                                           [(ngModel)]="data.visitorFullName"
                                           matInput required
                                           [matAutocomplete]="visitorFullName">
                                    <mat-autocomplete #visitorFullName="matAutocomplete">
                                        <mat-option *ngFor="let visitor of recentVisitorsList | filterByPropertyPipe: data.visitorFullName: 'fullName'"
                                                    (onSelectionChange)="changeAutocompleteValue(visitor)" [value]="visitor.fullName">
                                            {{ visitor.fullName + ', ' + visitor.vehicle + ', ' + visitor.licensePlate }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </div>
                            </div>
                        </div>

                        <!-- ___ Vehicle's Make/Model ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Vehicle's Make/Model</label>
                            </div>
                            <div class="col-md-8">
                                <div class="input-group fourteenPixelText autocomplete-input">
                                    <input name="visitorVehicle"
                                           [(ngModel)]="data.visitorVehicle"
                                           matInput required
                                           [matAutocomplete]="visitorVehicle">
                                    <mat-autocomplete #visitorVehicle="matAutocomplete">
                                        <mat-option *ngFor="let visitor of recentVisitorsList | filterByPropertyPipe: data.visitorVehicle: 'vehicle'"
                                                    (onSelectionChange)="changeAutocompleteValue(visitor)" [value]="visitor.vehicle">
                                            {{ visitor.fullName + ', ' + visitor.vehicle + ', ' + visitor.licensePlate }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </div>
                            </div>
                        </div>

                        <!-- ___ License Plate ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>License Plate</label>
                            </div>
                            <div class="col-md-8">
                                <div class="input-group fourteenPixelText autocomplete-input">
                                    <input name="visitorLicensePlate"
                                           [(ngModel)]="data.visitorLicensePlate"
                                           matInput required
                                           [matAutocomplete]="visitorLicensePlate">
                                    <mat-autocomplete #visitorLicensePlate="matAutocomplete">
                                        <mat-option *ngFor="let visitor of recentVisitorsList | filterByPropertyPipe: data.visitorLicensePlate: 'licensePlate'"
                                                    (onSelectionChange)="changeAutocompleteValue(visitor)" [value]="visitor.licensePlate">
                                            {{ visitor.fullName + ', ' + visitor.vehicle + ', ' + visitor.licensePlate }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="table">
                            <div class="display-inline">
                                <div class="table-cell">
                                    <div class="row m-b-sm">
                                        <div class="col-md-4">
                                            <label>Date From</label>
                                        </div>
                                        <div class="col-md-8 inlineDateAndTime">
                                            <mat-form-field>
                                                <input matInput [(ngModel)]="dateFrom"
                                                       [min]="today"
                                                       name="dateFrom"
                                                       (focus)="dateFromPicker.open()"
                                                       (click)="dateFromPicker.open()"
                                                       (ngModelChange)="onStartDateChange(form)"
                                                       [matDatepicker]="dateFromPicker"
                                                       placeholder="Choose a date" required>
                                                <mat-datepicker-toggle matSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
                                                <mat-datepicker #dateFromPicker></mat-datepicker>
                                            </mat-form-field>
                                            <div class="input-group bootstrap-timepicker timepicker"
                                                 (click)="openTimepicker('timepickerfrom')">
                                                <input id="timepickerfrom"
                                                       class="form-control input-small"
                                                       name="timeFrom"
                                                       [ngModel]="timeFrom" required>
                                                <span class="input-group-addon"><i class="glyphicon glyphicon-time"></i></span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row m-b-sm">
                                        <div class="col-md-4">
                                            <label>Date To</label>
                                        </div>
                                        <div class="col-md-8 inlineDateAndTime">
                                            <mat-form-field>
                                                <input matInput [(ngModel)]="dateTo"
                                                       [min]="dateFrom"
                                                       [max]="maxDateTo"
                                                       name="dateTo"
                                                       (focus)="dateToPicker.open()"
                                                       (click)="dateToPicker.open()"
                                                       (ngModelChange)="onDateTimeChange('dateTo')"
                                                       [matDatepicker]="dateToPicker"
                                                       placeholder="Choose a date" required>
                                                <mat-datepicker-toggle matSuffix [for]="dateToPicker"></mat-datepicker-toggle>
                                                <mat-datepicker #dateToPicker></mat-datepicker>
                                            </mat-form-field>
                                            <div class="input-group bootstrap-timepicker timepicker"
                                                 (click)="openTimepicker('timepickerto')">
                                                <input id="timepickerto"
                                                       class="form-control input-small"
                                                       name="timeTo"
                                                       [disabled]="!dateTo"
                                                       [ngModel]="timeTo" required>
                                                <span class="input-group-addon"><i class="glyphicon glyphicon-time"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="m-b-sm required-passes-container" *ngIf="requiredPasses.length > 0">
                            <div class="required-passes-row" *ngFor="let pass of requiredPasses; let index = index;">
                                <div>
                                    <label class="img-checkbox">
                                        <input id="selected{{index}}"
                                               type="checkbox"
                                               name="selected{{index}}"
                                               [disabled]="!pass.available && !pass.allowOverlimitBooking"
                                               [(ngModel)]="pass.selected">
                                        <label for="selected{{index}}"><svg-checked></svg-checked></label>
                                    </label>
                                </div>
                                <div>
                                    <div class="pass-name">{{pass.passTypeName}}</div>
                                </div>
                                <div>
                                    {{pass.startTime | date:'dd.MM.yyyy hh:mm a':'+0000'}} -
                                    {{pass.endTime | date:'dd.MM.yyyy hh:mm a':'+0000'}}
                                </div>
                                <div>
                                    <span *ngIf="pass.available">Available</span>
                                    <span *ngIf="!pass.available && !pass.allowOverlimitBooking" class="red-color">
                                        Not Available
                                    </span>
                                    <span *ngIf="!pass.available && pass.allowOverlimitBooking">Overlimit</span>
                                    <!--<span *ngIf="!pass.available && pass.allowOverlimitBooking && pass.fee">-->
                                        <!--Overlimit available with payment-->
                                    <!--</span>-->
                                    <!--<span *ngIf="!pass.available && pass.allowOverlimitBooking && !pass.fee">-->
                                        <!--Overlimit available-->
                                    <!--</span>-->
                                </div>
                            </div>
                        </div>

                        <div class="row m-t-md desktop-spinner" *ngIf="showRequiredPassTypesSpinner">
                            <div class="col-md-12">
                                <spinner [spinnerShow]="true"></spinner>
                            </div>
                        </div>

                        <div class="row text-center rule-details-hint-div m-b-sm" *ngIf="requiredPasses.length > 0">
                            <span class="clickable mtv-primary-color" (click)="showHint($event)">Rule Details</span>
                            <div class="rule-details-hint up">
                                <span *ngIf="rule && rule.minIntervalBetweenBooking">
                                    Minimum distance between bookings is {{rule.minIntervalBetweenBooking}}<br><br>
                                </span>
                                <div *ngFor="let pass of passesForHint; let last = last;">
                                    <span *ngIf="pass.name">Pass: {{pass.name}}<br></span>
                                    <span *ngIf="pass.maxTotalPassTypeCount && pass.maxTotalPassTypeSequenceType">
                                        Global pass limit: {{pass.maxTotalPassTypeCount}} per {{pass.maxTotalPassTypeSequenceType}}<br>
                                    </span>
                                    <span *ngIf="pass.maxOfDaysPerBooking">
                                        Max # of periods allowed per booking: {{pass.maxOfDaysPerBooking}}<br>
                                    </span>
                                    <span *ngIf="pass.maxPerSuiteCount && pass.maxPerSuiteSequenceType">
                                        Max Passes Per Unit: {{pass.maxPerSuiteCount}} per {{pass.maxPerSuiteSequenceType}}<br>
                                    </span>
                                    <span *ngIf="pass.maxPerLicensePlateCount && pass.maxPerLicensePlateSequenceType">
                                        Max Passes Per License Plate: {{pass.maxPerLicensePlateCount}} per {{pass.maxPerLicensePlateSequenceType}}<br>
                                    </span>
                                    <span>Allow overlimit booking: {{pass.allowOverlimitBooking ? 'Yes' : 'No'}}<br></span>
                                    <span *ngIf="pass.fee">Overlimit Booking Fee is: {{pass.fee + '$'}}<br></span>
                                    <br *ngIf="!last">
                                </div>
                                <div *ngFor="let limit of limitGroupsForHint;">
                                    <br>
                                    Common limit for
                                    <span *ngFor="let pass of limit.limitedPassTypes; let last = last;">
                                        {{pass.name}} <span *ngIf="!last">,</span>
                                    </span>
                                    is {{ limit.limitCount }} per {{ limit.limitSequenceType }}
                                </div>
                            </div>
                        </div>

                        <div class="row text-center delete-amenity-button btn-in-table m-b-sm" *ngIf="requiredPasses.length === 0">
                            <button class="btn submit refresh-button"
                                    type="button"
                                    [disabled]="disablePassRefresh"
                                    (click)="getRequiredPassTypes()">
                                Check Availability
                            </button>
                        </div>

                        <div class="row text-center m-b-sm" *ngIf="showNoPassesRequiredNotification">
                            No parking pass is required for the time you've selected
                        </div>

                        <div class="row text-center rule-details-hint-div m-b-lg">
                            <span class="clickable mtv-primary-color" (click)="showHint($event)">Help</span>
                            <div class="rule-details-hint up">
                                Please Enter: Visitor’s Name, Vehicle Make/ Model, License Plate, and The Dates and time the pass is
                                required for. Once done, click on the "Check Availability" button. (This will allocate the type of pass that
                                you are requesting) Then click, continue. You will now receive a summary of the Parking Pass. If everything is correct, click on confirm.
                            </div>
                        </div>
                    </div>
                    <div class="tab-content disclaimer-container" *ngIf="step == 'disclaimer'">
                        <div class="row m-b-sm" *ngIf="disclaimerText">
                            <div class="col-md-12 disclaimer-container">
                                <div class="acknowledgement-confirmation-textarea" [innerHTML]="disclaimerText | safeHtml"></div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-content" *ngIf="step == 'terms'">
                        <!-- ___ Notes  ___ -->
                        <div class="row m-b-sm" *ngIf="termsAndConditions">
                            <div class="col-md-12">
                                <div class="acknowledgement-confirmation-textarea" [innerHTML]="termsAndConditions | safeHtml"></div>
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="confirmationMessage">
                            <div class="img-checkbox col-sm-12">
                                <input type="checkbox" id="acknowledgementCheckbox" required
                                       name="acknowledgement" [(ngModel)]="data.acknowledgement">
                                <label for="acknowledgementCheckbox">
                                    <svg-checked></svg-checked>
                                    <span class="clickable">{{confirmationMessage}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="tab-content" *ngIf="step == 'payment'">
                        <!-- ___ Payment Method ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-5">
                                <label>Payment Method</label>
                            </div>
                            <div class="col-md-7">
                                <select class="form-control" name="paymentMethod" [(ngModel)]="data.paymentMethod">
                                    <option *ngFor="let method of availablePaymentMethods"
                                            [value]="method.value">{{method.displayName}}</option>
                                </select>
                            </div>
                        </div>
                        <div *ngIf="data.paymentMethod == 'credit_card'">
                            <!-- ___ Card Holder Name ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-5">
                                    <label>Card Holder Name</label>
                                </div>
                                <div class="col-md-7 fourteenPixelText">
                                    <input class="form-control" name="cardHolderName" [(ngModel)]="payment.cardHolderName">
                                </div>
                            </div>

                            <!-- ___ Postal Code ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-5">
                                    <label>Postal Code</label>
                                </div>
                                <div class="col-md-7 fourteenPixelText">
                                    <input class="form-control" name="postalCode" [(ngModel)]="payment.postalCode">
                                </div>
                            </div>

                            <!-- ___ Credit Card Number ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-5">
                                    <label>Credit Card Number</label>
                                </div>
                                <div class="col-md-7 fourteenPixelText">
                                    <input class="form-control" name="creditCardNumber" [(ngModel)]="payment.creditCardNumber">
                                </div>
                            </div>

                            <!-- ___ Expiry Date ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-5">
                                    <label>Expiry Date</label>
                                </div>
                                <div class="col-md-7 card-expiry-date-line">
                                    <select class="form-control" name="cardMonth" [(ngModel)]="payment.cardMonth">
                                        <option value="" hidden></option>
                                        <option *ngFor="let month of cardMonthArray" [value]="month">{{month}}</option>
                                    </select>
                                    <select class="form-control" name="cardYear" [(ngModel)]="payment.cardYear">
                                        <option value="" hidden></option>
                                        <option *ngFor="let year of cardYearsArray" [value]="year">{{year}}</option>
                                    </select>
                                </div>
                            </div>

                            <!-- ___ CVV ___ -->
                            <div class="row m-b-sm">
                                <div class="col-md-5">
                                    <label>CVV</label>
                                </div>
                                <div class="col-md-7 fourteenPixelText">
                                    <input class="form-control" name="cvv" [(ngModel)]="payment.cvv">
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="row m-b-sm sixteen-pixel-bold">
                            <div class="col-md-6">
                                <label>Total Payment Due</label>
                            </div>
                            <div class="col-md-3">
                                <label class="img-checkbox">
                                    <input id="fee"
                                           type="checkbox"
                                           name="fee"
                                           [disabled]="!data.paymentMethod"
                                           [(ngModel)]="data.payment.status">
                                    <label for="fee"><svg-checked></svg-checked></label>
                                    Paid
                                </label>
                            </div>
                            <div class="col-md-3 mtv-primary-color">
                                {{'$' + data.payment.amount}}
                            </div>
                        </div>
                    </div>
                    <div class="tab-content" *ngIf="step == 'summary'">
                        <div class="row m-b-sm" *ngIf="!authService.userIsResident">
                            <div class="col-md-6 col-xs-6">
                                <label>Building</label>
                            </div>
                            <div class="col-md-6 col-xs-6 fourteenPixelText">
                                {{getBuildingNameById(data.buildingId)}}
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="!authService.userIsResident">
                            <div class="col-md-6 col-xs-6">
                                <label>Unit</label>
                            </div>
                            <div class="col-md-6 col-xs-6 fourteenPixelText">
                                {{data.suiteNumber}}
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="!authService.userIsResident">
                            <div class="col-md-6 col-xs-6">
                                <label>Resident</label>
                            </div>
                            <div class="col-md-6 col-xs-6 fourteenPixelText">
                                {{data.residentFullName}}
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngFor="let pass of requiredPasses; let index = index;"
                             [ngClass]="{'display-none' : !pass.selected}">
                            <div class="col-md-2 col-xs-2">
                                <label *ngIf="index == 0">Passes</label>
                            </div>
                            <div class="col-md-10 col-xs-10 fourteenPixelText display-inline">
                                <div class="summary-pass-type-name">{{pass.passTypeName}}</div>
                                {{pass.startTime | date:'dd.MM.yyyy hh:mm a':'+0000'}} -
                                {{pass.endTime | date:'dd.MM.yyyy hh:mm a':'+0000'}}
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-6 col-xs-6">
                                <label>Visitor</label>
                            </div>
                            <div class="col-md-6 col-xs-6 fourteenPixelText">
                                {{data.visitorFullName}}
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-6 col-xs-6">
                                <label>Visitor's Vehicle Make/Model</label>
                            </div>
                            <div class="col-md-6 col-xs-6 fourteenPixelText">
                                {{data.visitorVehicle}}
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-6 col-xs-6">
                                <label>Visitor's License Plate</label>
                            </div>
                            <div class="col-md-6 col-xs-6 fourteenPixelText">
                                {{data.visitorLicensePlate}}
                            </div>
                        </div>

                        <!--<br *ngIf="availablePaymentMethods.length">-->

                        <!--<div class="row m-b-sm" *ngIf="availablePaymentMethods.length">-->
                            <!--<div class="col-md-6">-->
                                <!--<label>Method of Payment</label>-->
                            <!--</div>-->
                            <!--<div class="col-md-6 fourteenPixelText text-capitalize">-->
                                <!--{{data.paymentMethod == 'credit_card' ? 'Credit Card' : data.paymentMethod}}-->
                            <!--</div>-->
                        <!--</div>-->

                        <!--<div class="row m-b-sm" *ngIf="availablePaymentMethods.length">-->
                            <!--<div class="col-md-6">-->
                                <!--<label>Total Charges</label>-->
                            <!--</div>-->
                            <!--<div class="col-md-6 fourteenPixelText">-->
                                <!--{{'$' + getTotalPaymentValue()}}-->
                            <!--</div>-->
                        <!--</div>-->

                        <!--<div class="row text-center space-30 continue-button">-->
                            <!--<button class="btn btn-primary submit-btn" [disabled]="disabledSubmit"-->
                                    <!--(click)="confirmBooking()">Confirm</button>-->
                        <!--</div>-->
                    </div>

                    <div class="button-row row text-center space-30">
                        <button *ngIf="step == 'create-pass' && requiredPasses.length > 0"
                                class="btn btn-primary submit-btn"
                                type="submit"
                                [disabled]="isContinueButtonDisabled('create-pass')"
                                (click)="moveToTheNextStep(disclaimerText ? 'disclaimer' : (termsAndConditions || confirmationMessage ? 'terms' :(showPaymentTab() ? 'payment' : 'summary')))">
                            Continue
                        </button>

                        <button *ngIf="step == 'disclaimer'"
                                class="btn btn-primary submit-btn"
                                type="submit"
                                [disabled]="isContinueButtonDisabled('disclaimer')"
                                (click)="moveToTheNextStep(termsAndConditions || confirmationMessage ? 'terms' : (showPaymentTab() ? 'payment' : 'summary'))">
                            Continue
                        </button>

                        <button *ngIf="step == 'terms'"
                                class="btn btn-primary submit-btn"
                                type="submit"
                                [disabled]="isContinueButtonDisabled('terms')"
                                (click)="moveToTheNextStep(showPaymentTab() ? 'payment' : 'summary')">
                            Continue
                        </button>

                        <button *ngIf="step == 'payment'"
                                class="btn btn-primary submit-btn"
                                type="submit"
                                [disabled]="isContinueButtonDisabled('payment')"
                                (click)="moveToTheNextStep('summary')">
                            Continue
                        </button>

                        <button *ngIf="step == 'summary'"
                                class="btn btn-primary submit-btn"
                                [disabled]="disabledSubmit"
                                (click)="confirmBooking()">
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/parking-pass/parking-pass-modal/parking-pass-modal.component.html